import i18n from 'i18n'

import { Div } from 'ui'
import useResponsive from 'utils/hooks/useResponsive'

import PeopleImg_es from 'assets/images/beCreator/people_es.png'
import PeopleRespImg_es from 'assets/images/beCreator/peopleResponsive_es.png'
import PeopleImg_en from 'assets/images/beCreator/people_en.png'
import PeopleRespImg_en from 'assets/images/beCreator/peopleResponsive_en.png'


const PeopleImage = () => {

  const { isMobile, isTab, isBigDesktop } = useResponsive()

  const currentPeople = i18n.language === 'es' ? PeopleImg_es : PeopleImg_en
  const currentPeopleResp = i18n.language === 'es' ? PeopleRespImg_es : PeopleRespImg_en

  return (
    <Div
      flexGrow={isMobile ? 0 : 1}
      width={isBigDesktop ? 1000 : '95vw'}
      aspectRatio={isBigDesktop || isTab ? '16 / 9' : 'auto'}
      margin='0 auto'
      zIndex={1}
      position='relative'
      pointerEvents='none'
    >
      <Div
        backgroundImage={isMobile ? `url(${currentPeopleResp})` : `url(${currentPeople})`}
        backgroundSize='contain'
        backgroundPosition='bottom center'
        backgroundRepeat='no-repeat'
        position='absolute'
        width={isTab || isBigDesktop ? '135%' : '120%'}
        height={isTab || isBigDesktop ? '135%' : '120%'}
        bottom={0}
        left='50%'
        transform='translateX(-50%)'
      />
    </Div>
  )
}

export default PeopleImage